import HomePage from "./pages/HomePage.jsx";
import AboutPage from "./pages/AboutPage.jsx";
import ContactPage from "./pages/ContactPage.jsx";
import ProjectListPage from "./pages/ProjectListPage.jsx";
import VenturesPage from "./pages/VenturesPage.jsx";
import ProjectPage from "./pages/ProjectPage.jsx";
import ErrorPage from "./pages/ErrorPage.jsx";

const pageTypes = {
  "home.HomePage": HomePage,
  "about.AboutPage": AboutPage,
  "contact.ContactPage": ContactPage,
  "work.ProjectListPage": ProjectListPage,
  "work.ProjectPage": ProjectPage,
  "ventures.VenturesPage": VenturesPage,
};

function App({ coreData, pageData, pathName }) {
  // Handle 404 case
  if (pageData === null) {
    return <ErrorPage coreData={coreData} pathName={pathName} />;
  }

  // Get the appropriate component based on page type
  const Component = pageTypes[pageData.meta.type];

  // Fallback to ErrorPage if component not found
  if (!Component) {
    console.warn(`Unknown page type: ${pageData.meta.type}`);
    return <ErrorPage coreData={coreData} pathName={pathName} />;
  }

  return (
    <Component coreData={coreData} pageData={pageData} pathName={pathName} />
  );
}

export default App;
